import request from '@/router/axios'
// 发票
export function getInvoiceList(data) {
  return request({
    url: '/api/admin/invoice/downInvoicePDF',
    method: 'get',
    params: data
  })
}
export const getList = (pageNum, pageSize, params) => {
  return request({
    url: '/api/admin/commodity/issueList',
    method: 'get',
    params: { pageNum, pageSize, ...params }
  })
}

export const getInfo = (id) => {
  return request({
    url: `/api/admin/commodity/info/${id}`,
    method: 'get'
  })
}

export const getCountCart = () => {
  return request({
    url: `/api/admin/commodityCart/countCart`,
    method: 'get'
  })
}

export const commodityCart = (data) => {
  return request({
    url: `/api/admin/commodityCart`,
    method: 'post',
    data
  })
}

// 购物车列表
export const getCartList = (pageNum, pageSize, params) => {
  return request({
    url: '/api/admin/commodityCart/list',
    method: 'get',
    params: { pageNum, pageSize, ...params }
  })
}

// 删除购物车
export const delCart = (ids) => {
  return request({
    url: `/api/admin/commodityCart/${ids}`,
    method: 'DELETE'
  })
}

// 下单时计算各墓位综合服务费
export const countGraveArrearsForOrder = (params) => {
  return request({
    url: '/api/admin/storeOrder/countGraveArrearsForOrder',
    method: 'get',
    params
  })
}

// 单个商品下单
export const addForH5 = (data) => {
  return request({
    url: `/api/admin/storeOrder/addForH5`,
    method: 'post',
    data
  })
}

// 购物车商品下单
export const submitOrderCart = (data) => {
  return request({
    url: `/api/admin/commodityCart/submitOrder`,
    method: 'post',
    data
  })
}

// 获取订单详情
export const storeOrderInfo = (id) => {
  return request({
    url: '/api/admin/storeOrder/info/' + id,
    method: 'get'
  })
}

// 获取订单列表
export const getOrderList = (pageNum, pageSize, params) => {
  return request({
    url: '/api/admin/storeOrder/list',
    method: 'get',
    params: { pageNum, pageSize, ...params }
  })
}

// 预支付
export const launchPay = (params) => {
  return request({
    url: '/api/admin/storeOrder/launchPayForH5',
    method: 'get',
    params
  })
}

// 取消订单
export const closeOrder = (params) => {
  return request({
    url: '/api/admin/storeOrder/closeOrder',
    method: 'get',
    params
  })
}
